import { S3Item } from 'types';

const filterThumbs = (urls: S3Item[]) =>
  urls.filter((item) => item.key.slice(-9) !== 'Thumbs.db');

export { filterThumbs };
